import { types } from '../actions/types';

const initialState = {
    loading: false,
    data: {},
    error: {},
};

const getCordinatesReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case types.SEND_REQUEST_GET_COORDINATES:
            return {
                ...state,
                loading: true,
            };
        case types.SEND_REQUEST_GET_COORDINATES_SUCCESS:
            return {
                ...state,
                data: payload,
                loading: false,
            };
        case types.SEND_REQUEST_GET_COORDINATES_FAILURE:
            return {
                ...state,
                data: {},
                error: payload,
                loading: false,
            };
        case types.CLEAR_REQUEST_GET_COORDINATES:
            return {
                ...state,
                data: {},
                loading: false,
            };
        default:
            return state;
    }
};

export default getCordinatesReducer
